if (!customElements.get("product-cashpoints")) {
  class ProductCashpoints extends HTMLElement {
    constructor() {
      super();
      this.points = Math.ceil(this.dataset.price / Number(Shopify.currency.rate) / 100);
      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.variantCp = parseInt(this.dataset.variantCp);
      this.dofetch = this.dataset.fetch === "true";
      this.pointsEl = this.querySelector(".cashpoints-points span");
    }

    connectedCallback() {
      this.pointsEl.innerHTML = this.variantCp || this.points;
      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => {
          if (this.dofetch && !this.variantCp) this.fetch();
        });
      } else {
        window.setTimeout(() => {
          if (this.dofetch && !this.variantCp) this.fetch();
        }, 100); 
      }
    }

    fetch() {
      const url = new URL(location.pathname, "https://www.titus.at");
      fetch(url)
        .then((response) => {
          if (response.status !== 200) {
            throw new Error("Network response was not ok.");
          }
          if (!response.redirected) {
            return fetch(url + ".json");
          } else {
            return fetch(response.url + ".json");
          }
        })
        .then((response) => response.json())
        .then((data) => {
          const price = Number(data.product.variants.filter((variant) => variant.id == this.variantId)[0].price);
          this.pointsEl.innerHTML = Math.ceil(price);
        });
    }
  }

  customElements.define("product-cashpoints", ProductCashpoints);
}
